import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';

import { FieldType, FormlyField, FormlyFieldConfig } from '@ngx-formly/core';

// From https://formly.dev/docs/examples/advanced/tabs/
@Component({
  selector: 'ts-form-field-tabs-ui',
  templateUrl: './form-field-tabs-ui.component.html',
  styleUrls: ['./form-field-tabs-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatTabsModule, FormlyField],
})
export class FormFieldTabsUiComponent extends FieldType {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }
}
